import React from 'react';

import {pure} from 'recompose';

import avatarPic from '../static/avatar3.jpeg';
import userPic from '../static/user.png';

import "./Avatar.css";

const AvatarWrapper = (props) => (
  <img
    className="avatar"
    alt="Avatar"
    src={props.for === 'ai' ? avatarPic : userPic}
    style={{
      border: props.border ? '2px solid #4fc3ea' : 'none',
      width: props.size,
      height: props.size,
      minWidth: props.size,
      minHeight: props.size,
      ...props.style,
    }}
  />
)

AvatarWrapper.defaultProps = {
  border: false,
  mx: 1
};

export default pure(AvatarWrapper);



// WEBPACK FOOTER //
// ./src/components/Avatar.js